import Vue from 'vue';
import App from './App.vue';
import router from './router';
import './assets/css/global.css';
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Aegis from '@tencent/aegis-web-sdk'; // 勿删，tam 前端监控
import Ant from "ant-design-vue";
import "ant-design-vue/dist/antd.css";

const aegis = new Aegis({
  id: 'KfYymSLxNhbcHSHNJX', // 项目key
  uin: 'xxx', // 用户唯一 ID（可选）
  reportApiSpeed: true, // 接口测速
  reportAssetSpeed: true, // 静态资源测速
  spa: true, // spa 页面需要开启，页面切换的时候上报pv
})

Vue.config.productionTip = false;
Vue.use(ElementUI)
Vue.use(Ant)
new Vue({
    router,
  render: h => h(App),
}).$mount('#app');
